<template>
  <div class="offline-overlay">
    <div
      class="offline-overlay__reload"
      @click="handleReload"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
        fill="#1f1f1f"
      >
        <path
          :d="`M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55
              7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13
              11h7V4l-2.35 2.35z`"
        />
      </svg>
    </div>
    <div class="offline-overlay__content">
      <div class="offline-overlay__content-title">
        No Internet Connection
      </div>
      <div class="offline-overlay__content-message">
        No network connection detected.
        <br>
        Please check your internet connection.
        <br>
        Try again once the connection is restored.
        <hr>
        Keine Netzwerkverbindung erkannt.
        <br>
        Bitte überprüfen Sie Ihre Internetverbindung.
        <br>
        Versuchen Sie es erneut, sobald die Verbindung wiederhergestellt ist.
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted, onUnmounted } from 'vue';
import useMqtt from '@/composables/useMqtt';

export default defineComponent({
  name: 'OfflineOverlay',
  setup() {
    const { isInitialized } = useMqtt();

    function handleReload() {
      window.location.reload();
    }

    function handleOnline() {
      if (!isInitialized()) {
        handleReload(); // reload page if it was not initialized
      }
    }

    onMounted(() => {
      window.addEventListener('online', handleOnline);
    });

    onUnmounted(() => {
      window.removeEventListener('online', handleOnline);
    });

    return {
      handleReload,
    };
  },
});
</script>

<style scoped lang="scss">
.offline-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #C6C7C9;
  z-index: 1000;

  &__content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 500px;
    max-width: 100%;
    margin: 0 auto;

    &-title {
      padding: 20px;
      background-color: #1E58F2;
      font-size: 32px;
      font-weight: 600;
      color: #ffffff;
      width: 100%;
    }

    &-message {
      padding: 20px;
      font-size: 18px;
      background-color: #fff;
      color: #000000;
      width: 100%;
    }
  }

  &__reload {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
    background-color: #fff;
    border-radius: 50%;
    width: 48px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      width: 32px;
      height: 32px;
    }
  }
}
</style>
